/**
 * Slug do evento resolvido pelo edge (Global Config, com `DOMAIN_MAP` de
 * fallback), entregue ao navegador para que o client opere sobre o mesmo
 * tenant que o middleware escolheu — em vez de adivinhá-lo pelo host.
 *
 * Mesmo canal de `TENANT_IDENTITY_COOKIE`, pelos mesmos motivos: header de
 * navegação não é legível por JS e reescrever o HTML custaria o cache do
 * documento. Não é `HttpOnly` porque quem lê é JavaScript de documento, e o
 * slug é público.
 */
export const TENANT_SLUG_COOKIE = 'evnttz_tenant_slug'

/**
 * O valor vai para a URL da api (`/public/digital_products/{slug}`) e o
 * cookie é editável pelo usuário: fora deste formato, é tratado como ausente.
 */
const SLUG_FORMAT = /^[a-z0-9][a-z0-9-]*$/

/**
 * Cookie de sessão, reescrito pelo edge a cada resposta de documento. Sem
 * `Max-Age`: herdar a hora do cookie de identidade faria um reponte levar até
 * uma hora para alcançar um visitante recorrente. Sem `Domain`: host-only, o
 * cookie de um evento nunca é lido no subdomínio de outro.
 */
export function serializeTenantSlugCookie(slug: string): string {
  return `${TENANT_SLUG_COOKIE}=${encodeURIComponent(slug)}; Path=/; SameSite=Lax`
}

/** Emitido em `/sem-evento`: nenhum slug anterior sobrevive num host sem evento. */
export function expireTenantSlugCookie(): string {
  return `${TENANT_SLUG_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax`
}

/** Lê o slug de um header `Cookie` ou de `document.cookie`. */
export function readTenantSlugCookie(
  cookieHeader: string | null | undefined
): string | null {
  if (!cookieHeader) return null

  for (const parte of cookieHeader.split(';')) {
    const separador = parte.indexOf('=')
    if (separador === -1) continue

    if (parte.slice(0, separador).trim() !== TENANT_SLUG_COOKIE) continue

    try {
      const slug = decodeURIComponent(parte.slice(separador + 1).trim())
      return SLUG_FORMAT.test(slug) ? slug : null
    } catch {
      return null
    }
  }

  return null
}
